export default __webpack_public_path__ + "static/media/xbox.df092e31.svg";